var moveList = [
    {
        path: '/operateXn',
        name: 'operateXn',
        meta: {
            activeNav: 'operateIndex',
        },
        component: () => import('../views/operateXn/index.vue')
    }, {
        path: '/traceIndexXn',
        name: 'traceIndexXn',
        meta: {
            activeNav: 'traceIndex',
        },
        component: () => import('../views/operateXn/traceIndex.vue')
    }, {
        path: '/traceInfoXn',
        name: 'traceInfoXn',
        meta: {
            activeNav: 'traceIndex',
        },
        component: () => import('../views/operateXn/traceInfo.vue')
    },

    {
        path: '/breederXn',
        name: 'breederXn',
        meta: {
            activeNav: 'breederIndex',
        },
        component: () => import('../views/breederXn/index.vue')
    },
    {
        path: '/detailsXn',
        name: 'detailsXn',
        meta: {
            activeNav: 'breederIndex',
        },
        component: () => import('../views/breederXn/details.vue')
    },
    {
        path: '/archivesXn',
        name: 'archivesXn',
        meta: {
            activeNav: 'breederIndex',
        },
        component: () => import('../views/breederXn/archives.vue')
    },

    {
        path: '/livestockXn',
        name: 'livestockXn',
        meta: {
            activeNav: 'livestock',
        },
        component: () => import('../views/livestockXn/index.vue')
    },

    {
        path: '/transactionXn',
        name: 'transactionXn',
        meta: {
            activeNav: 'transactionIndex',
        },
        component: () => import('../views/transactionXn/index.vue')
    }, 
    {
        path: '/financialXn',
        name: 'financialXn',
        meta: {
            activeNav: 'financialIndex',
        },
        component: () => import('@/views/financialXn/index.vue')
    },

    {
        path: '/slaughterXn',
        name: 'slaughterXn',
        meta: {
            activeNav: 'slaughter',
        },
        component: () => import('../views/slaughterXn/index.vue')
    },
    {
        path: '/detailXn',
        name: 'detailXn',
        meta: {
            activeNav: 'slaughter',
        },
        component: () => import('../views/slaughterXn/detail.vue')
    },

    {
        path: '/traceIndexXn',
        name: 'traceIndexXn',
        meta: {
            activeNav: 'traceIndex',
        },
        component: () => import('../views/operateXn/traceIndex.vue')
    }, {
        path: '/traceInfoXn',
        name: 'traceInfoXn',
        meta: {
            activeNav: 'traceIndex',
        },
        component: () => import('../views/operateXn/traceInfo.vue')
    },
]
export default moveList